








import { Component, Vue, Prop } from 'vue-property-decorator'
import { RawLocation } from 'vue-router'

interface IItem {
  text: string,
  routeName: string
}

@Component
export default class Sidebar extends Vue {
  @Prop()
  list!: IItem[]

  get activeIndex () {
    return this.list.findIndex((item: IItem) => item.routeName === this.$route.name)
  }

  handleClick (item: IItem, index: number) {
    this.$router.push({ name: item.routeName })
  }
}
